import { createReducer, on } from '@ngrx/store';
import * as MeasurementItemsMxActions from './measurement-items-mx.actions';

export interface MeasurementItemsMxState {
  response: any[] | null;
  error: any | null;
  loading: boolean;
  cache?: { [key: string]: any[] };
}

export const initialState: MeasurementItemsMxState = {
  response: null,
  error: null,
  loading: false,
  cache: {},
};

export const measurementItemsMxReducer = createReducer(
  initialState,
  on(MeasurementItemsMxActions.loadMeasurementItemsMx, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(MeasurementItemsMxActions.loadMeasurementItemsMxSuccess, (state, { response }) => ({
    ...state,
    loading: false,
    response,
    error: null,
  })),
  on(MeasurementItemsMxActions.loadMeasurementItemsMxFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(MeasurementItemsMxActions.loadMeasurementItemsMxSuccessByKey, (state, { key, response }) => ({
    ...state,
    loading: false,
    response,
    cache: { ...(state.cache || {}), [key]: response },
    error: null,
  })),
);
